import { gql, TypedDocumentNode } from '@apollo/client';

import { IStartStripeSessionQueryGraphQLResponse, IStartStripeSessionQueryVariables } from './useStartStripeSession.interfaces';

const START_STRIPE_SESSION_QUERY = gql`
  query ($id: String!, $product: EProduct!, $returnUrl: String!) {
    projects {
      startStripeSession(id: $id, product: $product, returnUrl: $returnUrl) {
        url
      }
    }
  }
` as TypedDocumentNode<
  IStartStripeSessionQueryGraphQLResponse,
  IStartStripeSessionQueryVariables
>; 

export { START_STRIPE_SESSION_QUERY };
